var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFloatingCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heading"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2641_6047)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.86941 4.15869C8.05818 4.36024 8.04782 4.67665 7.84627 4.86542L6.01274 6.8229C5.82026 7.00318 5.52085 7.00297 5.32862 6.82241L4.15768 5.57218C3.95641 5.38312 3.9465 5.0667 4.13556 4.86542C4.32462 4.66415 4.64105 4.65424 4.84232 4.8433L5.67144 5.77246L7.16268 4.13556C7.36423 3.94679 7.68064 3.95715 7.86941 4.15869ZM9.5 5C9.22386 5 9 5.22386 9 5.5C9 5.77614 9.22386 6 9.5 6H15.5C15.7761 6 16 5.77614 16 5.5C16 5.22386 15.7761 5 15.5 5H9.5ZM9.5 9.5C9.22386 9.5 9 9.72386 9 10C9 10.2761 9.22386 10.5 9.5 10.5H15.5C15.7761 10.5 16 10.2761 16 10C16 9.72386 15.7761 9.5 15.5 9.5H9.5ZM9 14.5C9 14.2238 9.22386 14 9.5 14H15.5C15.7761 14 16 14.2238 16 14.5C16 14.7761 15.7761 15 15.5 15H9.5C9.22386 15 9 14.7761 9 14.5ZM7.84627 9.36493C8.04782 9.17617 8.05818 8.85975 7.86941 8.65821C7.68064 8.45666 7.36423 8.4463 7.16268 8.63507L5.67144 10.272L4.84232 9.34281C4.64105 9.15376 4.32462 9.16366 4.13556 9.36493C3.9465 9.56621 3.95641 9.88264 4.15768 10.0717L5.32862 11.3219C5.52085 11.5025 5.82026 11.5027 6.01274 11.3224L7.84627 9.36493ZM7.84627 13.8654C8.04782 13.6767 8.05818 13.3602 7.86941 13.1587C7.68064 12.9571 7.36423 12.9468 7.16268 13.1356L5.67144 14.7725L4.84232 13.8433C4.64105 13.6542 4.32462 13.6641 4.13556 13.8654C3.9465 14.0667 3.95641 14.3831 4.15768 14.5722L5.32862 15.8224C5.52085 16.003 5.82026 16.0032 6.01274 15.8229L7.84627 13.8654Z",
    fill: "#596169"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 19.5,
    height: 19.5,
    rx: 1.75,
    stroke: "#DEE2E6",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2641_6047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatingCheck);
export default __webpack_public_path__ + "static/media/floating-check.980d200ae2b47e30f893421aec499fc0.svg";
export { ForwardRef as ReactComponent };